import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "search--sprite",
  "use": "search--sprite-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"search--sprite\">\n    <path fill=\"#FFF\" stroke=\"#FFF\" stroke-width=\".2\" d=\"M25.786 24.521l-5.891-5.602c3.005-3.016 2.931-7.76-.167-10.691-3.098-2.93-8.088-2.976-11.245-.103C5.327 11 5.157 15.742 8.101 18.812c2.944 3.07 7.927 3.347 11.227.623l5.902 5.613.556-.527zM6.808 13.651c0-3.804 3.244-6.889 7.245-6.889 4.002 0 7.245 3.085 7.245 6.89 0 3.804-3.243 6.889-7.245 6.889-4 0-7.243-3.082-7.245-6.885v-.005z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol